<template>
    <div class="Cooperation">
        <el-row style="margin-top:2rem;">
            <el-col :span="14" :offset="5">
                <div class="line"></div>
                <el-row>
                    <el-col class="list" :span="4" :offset="index%3==0?0:6" v-for="(item, index) in data" :key="index">
                        <img :src="`${baseUrl}img/business/${item}`" width="100%" alt="" srcset="">
                    </el-col>
                </el-row>
                <div class="line"></div>
                
            </el-col>
        </el-row>
    </div>
</template>
<script>
export default {
    data() {
        return {
            baseUrl:process.env.BASE_URL, 
        }
    },
    props:['data']
}
</script>
<style lang="less">
.Cooperation{
    margin-top: 2rem;
    margin-bottom: 8rem;
    .list{
        margin-top: 2rem;
        // margin: 2rem 0;
    }
    .line{
        width: 100%;
        height: 1px;
        background-color: #BFBFBF;
        margin-top: 2rem;
        margin-bottom: 2rem;
    }
}
</style>

